export default __webpack_public_path__ + "static/media/icon-cashback-redeemed.9c5f3298.svg";